import { Grid, ThemeProvider, Typography, createTheme } from '@mui/material';
import React from 'react'
import PropTypes from "prop-types";


const theme = createTheme({
    typography: {
      h6: {
        fontFamily: "Texta-bold",
      },
      subtitle1: {
        fontFamily: ["Texta-book", "Helvetica", "Arial", "sans-serif"].join(','),
        fontSize: 20,
      },
    },
  });
const SnapCSALocationDetail = ({row}) => { 
  return (
    <Grid container className="collapsibleTable" spacing={2}>
        <ThemeProvider theme={theme}>
            {row.shareNam && (
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom component="div">
                    Share Name List
                 </Typography>
                 <Typography variant="subtitle1" gutterBottom>
                    {row.shareNam ? row.shareNam : '-'}
                </Typography>  
            </Grid> )}
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom component="div">
                    Latitude
                 </Typography>
                 <Typography variant="label" gutterBottom>
                    {row.latitude ? row.latitude : '-'}
                </Typography>  
            </Grid>
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom component="div">
                    Longitude
                 </Typography>
                 <Typography variant="label" gutterBottom>
                    {row.longitude ? row.longitude : '-'}
                </Typography>  
            </Grid>
        </ThemeProvider>

    </Grid>
  )
}


SnapCSALocationDetail.propTypes = {
    row: PropTypes.object.isRequired,

};

export default SnapCSALocationDetail